import { create } from 'zustand';

type Theme = 'dark' | 'light';
type Locale = 'fa' | 'en';

interface ThemeState {
  theme: Theme;
  locale: Locale;
  toggleTheme: () => void;
  setLocale: (locale: Locale) => void;
}

export const useThemeStore = create<ThemeState>((set) => {
  const initialTheme = (localStorage.getItem('fretboard_theme') as Theme) || 'dark';
  const initialLocale = (localStorage.getItem('fretboard_locale') as Locale) || 'fa';

  // Apply initial HTML attributes
  document.documentElement.setAttribute('data-theme', initialTheme);
  document.documentElement.setAttribute('lang', initialLocale);
  document.documentElement.setAttribute('dir', initialLocale === 'fa' ? 'rtl' : 'ltr');

  return {
    theme: initialTheme,
    locale: initialLocale,

    toggleTheme: () => {
      set((state) => {
        const newTheme: Theme = state.theme === 'dark' ? 'light' : 'dark';
        localStorage.setItem('fretboard_theme', newTheme);
        document.documentElement.setAttribute('data-theme', newTheme);
        return { theme: newTheme };
      });
    },

    setLocale: (locale: Locale) => {
      localStorage.setItem('fretboard_locale', locale);
      document.documentElement.setAttribute('lang', locale);
      document.documentElement.setAttribute('dir', locale === 'fa' ? 'rtl' : 'ltr');
      set({ locale });
    }
  };
});
